import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({documentos: {documento: []}})

/* Types */
export const SET_DOCUMENTS = 'SET_DOCUMENTS'


/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case SET_DOCUMENTS:
			return new Immutable.Map(action.dataObj)
		default:
			return state;
	}
};

/* Action Creators */

export const getGeneralInfo = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getInfoGeneral',
			method: "POST",
			data: { ...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false));

			console.log(response);
			let llaves = Object.keys(response);

			for (var key in llaves) {
			  response[llaves[key]] = response[llaves[key]] === null ? null : cryptr.decrypt(response[llaves[key]]);
			}

			console.log(response ,'JSON desencryptado');

			if (response.key.length > 0) {
			  for (var key in response.key) {
			    response[response.key[key]] = JSON.parse(response[response.key[key]]);
			  }
			}

			console.log(response,'JSON COMO ANTES');

			let dataObj = {
				cluni: response.data.informacionGeneral.cluni,
				constitutionDate: new Date(Number(response.data.informacionGeneral.fechaConstitucion)).toISOString(),
				operationsDate: new Date(Number(response.data.informacionGeneral.fechaInicioOperacion)).toISOString(),
				iap: response.data.informacionGeneral.transformadaIAP,
				jap: response.data.informacionGeneral.organismoRegulador.id,
				socialIntervention: response.data.informacionGeneral.intervencionSocial,
			}

			dispatch({type: SET_DOCUMENTS, dataObj })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const setGeneralInfo = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/setInfoGeneral',
			method: "POST",
			data: form,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch({type: SET_DOCUMENTS, dataObj: form})
			dispatch(isLoading(false))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Register/Documents.js